import {NgModule} from '@angular/core';
import {PushNotificationsService} from './push-notifications.service';

@NgModule({
    providers: [PushNotificationsService]
})
export class PushNotificationsModule {}


// WEBPACK FOOTER //
// ./~/angular2-notifications/src/push-notifications.module.ts